import { Stack, Typography } from '@healthinal/ui';
import { ChangeLogEntityType, useGetChangeLogByEntitySuspense } from '../../../../api/created/changeLog.ts';
import {
  useGetCountriesSuspense,
  useGetLanguagesSuspense,
} from '../../../../api/generated/locale-controller/locale-controller.ts';
import { useGetPersonByIdSuspense } from '../../../../api/generated/person-controller/person-controller.ts';
import { useUsersSuspense } from '../../../../api/created/users.ts';
import { ChangeHistoryEntry } from '../../../../components/history/ChangeHistoryEntry.tsx';
import { mapChangeLogEntriesToPersonHistory } from './personHistory.ts';

export function PersonHistory({ personId }: { personId: string }) {
  const { data: person } = useGetPersonByIdSuspense(personId);
  const { data: changeLogEntries } = useGetChangeLogByEntitySuspense(ChangeLogEntityType.PERSON, personId);
  const { data: users } = useUsersSuspense();
  const { data: countries } = useGetCountriesSuspense();
  const { data: languages } = useGetLanguagesSuspense();
  const historyEntries = mapChangeLogEntriesToPersonHistory(changeLogEntries, {
    users,
    countries,
    languages,
  });
  const personName = `${person?.firstName ?? ''} ${person?.lastName ?? ''}`.trim();

  return (
    <Stack gap={2}>
      <Typography level={'h3'}>Persönlicher Werdegang</Typography>
      <Stack gap={2}>
        {historyEntries.length === 0 ? (
          <Typography level={'body-md'}>Keine Einträge vorhanden.</Typography>
        ) : (
          historyEntries.map((entry) => (
            <ChangeHistoryEntry
              key={entry.id}
              entry={entry}
              subject={'Die Personalien von'}
              entityName={personName}
              actionLabel={entry.actionLabel}
              changedBy={entry.changedByName}
            />
          ))
        )}
      </Stack>
    </Stack>
  );
}
